import { useEffect, useRef } from 'react';
import { StepperContentProps } from '.';
import { Input } from '../../../../../../components';
import useStyles from './styles';

type RuleProps = Omit<StepperContentProps, 'activeStep' | 'handleUpload' | 'file'>;

export const Rules = ({
  service,
  shouldValidate,
  handleSetSelectedService,
  validate,
  setShouldValidate,
}: RuleProps): JSX.Element => {
  const styles = useStyles();

  useEffect(() => {
    if (shouldValidate) {
      validate(true);
      setShouldValidate(false);
    }
  }, [shouldValidate, validate, setShouldValidate]);

  const handleOnChange = (value?: string) => {
    handleSetSelectedService({
      ...service,
      instructions: value ?? undefined,
    });
  };

  const ref = useRef();

  // workaround: use it to fetch input value on input component if is empty
  useEffect(() => {
    const element = ref.current as unknown as HTMLInputElement;

    element.value = service.instructions ?? '';
  }, [service]);

  return (
    <div className={styles.container}>
      <Input
        inputRef={ref}
        multiline
        minRows={12}
        maxRows={15}
        label="regras de uso"
        textArea
        value={service.instructions ?? ''}
        onChange={(e) => handleOnChange(e.target.value)}
      />
    </div>
  );
};

export default Rules;
